import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Minimal preconnect for critical domains only
const preconnectLinks = [
  'https://readdy.ai',
  'https://checkout.razorpay.com'
];

preconnectLinks.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  document.head.appendChild(link);
});

// Only preload hero background image - most critical
const heroImage = document.createElement('link');
heroImage.rel = 'preload';
heroImage.as = 'image';
heroImage.href = 'https://public.readdy.ai/ai/img_res/328da0602ab91f8c7f7b487a7875f650.jpg';
heroImage.fetchPriority = 'high';
document.head.appendChild(heroImage);

// Delayed prefetch for non-critical resources - only on WiFi
if ('connection' in navigator) {
  const connection = (navigator as any).connection;
  if (!connection || connection.effectiveType === '4g' || connection.effectiveType === 'wifi') {
    setTimeout(() => {
      // Prefetch checkout page
      const checkoutPrefetch = document.createElement('link');
      checkoutPrefetch.rel = 'prefetch';
      checkoutPrefetch.href = '/checkout';
      document.head.appendChild(checkoutPrefetch);
      
      // Lazy load Razorpay only when needed
      const razorpayPrefetch = document.createElement('link');
      razorpayPrefetch.rel = 'dns-prefetch';
      razorpayPrefetch.href = 'https://api.razorpay.com';
      document.head.appendChild(razorpayPrefetch);
    }, 3000);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)